var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({staticClass:"h-full"},_vm.$listeners),[_c('v-layout',{staticClass:"h-full",class:`gap-${_vm.gap}`,attrs:{"align-center":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }